export default __webpack_public_path__ + "static/media/instruction3.cb319717.png";